var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53651 6.65121H5.8668H3.46277C3.05138 6.65121 2.84569 7.1483 3.13709 7.4397L5.35685 9.65945C5.71253 10.0151 6.29104 10.0151 6.64671 9.65945L7.49091 8.81526L8.86647 7.4397C9.15359 7.1483 8.94789 6.65121 8.53651 6.65121Z",
    fill: "#A3A4A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86298 3.98744L7.4869 2.61136L6.64668 1.76686C6.29087 1.41105 5.71214 1.41105 5.35633 1.76686L3.13574 3.98744C2.84424 4.27894 3.05429 4.77622 3.46155 4.77622H5.86647H8.53718C8.94872 4.77622 9.15449 4.27894 8.86298 3.98744Z",
    fill: "#A3A4A8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputicon);
export default __webpack_public_path__ + "static/media/inputicon.a03fa834.svg";
export { ForwardRef as ReactComponent };